import { Link } from "react-router-dom";
import Logo from "./Logo";
import { REQUISITES, SITE } from "./siteConfig";

const Footer = () => (
    <footer className="ftr">
        <div className="wrap ftr__in">
            <div className="ftr__col">
                <Logo size="sm" />
                <p>
                    <strong>{SITE.brand}</strong> — продажа юридических лидов юристам, адвокатам
                    и юридическим компаниям по всей России с {SITE.since} года.
                </p>
            </div>
            <div className="ftr__col">
                <b>Контакты</b>
                {SITE.phone && <a href={`tel:${SITE.phoneLink}`}>{SITE.phone}</a>}
                <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
                <span>{SITE.office}</span>
            </div>
            <div className="ftr__col">
                <b>Документы</b>
                <Link to="/privacy">Политика обработки персональных данных</Link>
                <Link to="/consent">Согласие на обработку персональных данных</Link>
                <a href="#faq">Вопросы и ответы</a>
            </div>
        </div>

        {/* Реквизиты: ст. 9 Закона РФ «О защите прав потребителей» */}
        <div className="wrap ftr__req">
            <b>Реквизиты</b>
            <dl>
                <div>
                    <dt>Наименование</dt>
                    <dd>{REQUISITES.legalName}</dd>
                </div>
                <div>
                    <dt>ОГРНИП</dt>
                    <dd>{REQUISITES.ogrnip}</dd>
                </div>
                <div>
                    <dt>ИНН</dt>
                    <dd>{REQUISITES.inn}</dd>
                </div>
                <div>
                    <dt>Адрес</dt>
                    <dd>{REQUISITES.address}</dd>
                </div>
                {SITE.phone && (
                    <div>
                        <dt>Телефон</dt>
                        <dd>
                            <a href={`tel:${SITE.phoneLink}`}>{SITE.phone}</a>
                        </dd>
                    </div>
                )}
                <div>
                    <dt>Электронная почта</dt>
                    <dd>
                        <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
                    </dd>
                </div>
            </dl>
            <p className="ftr__req-note">
                Информация на сайте не является публичной офертой (ст. 437 ГК РФ). Стоимость
                и условия закупки лидов определяются договором.
            </p>
        </div>

        <div className="wrap ftr__bottom">
            <span>
                © {new Date().getFullYear()} {SITE.brand} · {REQUISITES.shortName}
            </span>
            <Link to="/privacy">Политика конфиденциальности</Link>
        </div>
    </footer>
);

export default Footer;
